import locale from "@packs/locale/locale"
import stationHelper from "../../../helpers/station_helper"
import store from "../../../store/store"
import('./chart.scss')

export default function Chart(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this
    let _chart
    let current_station

    this.generate = () =>{
        $(container).html('')
        elements.container = this.createElement('div', '', '')
        $(elements.container).css({
            height: '500px',
            width: '100%',
            position: 'relative'
        })

        elements.see_more_button = context.createElement('button', 'information-card-see-more-button', 'Ver mais')
        elements.see_more_button.type = 'button'

        $(elements.see_more_button).on('click', () =>{
            this.trigger('seemore-button-click', current_station)
        })

        $(container).append(elements.container,elements.see_more_button)
    }

    this.update = (station) =>{
        
        //station can be a array
        current_station = station

        //chart is destroyed when is not being used
        if(_chart){
            //destroying chart
            this.destroy() 

            
        } else {
            //generating html estructure
            this.generate() 
            
        }

        generateChart(station)
        
        //chart already exist, updating
        // updateChart(station)
    }

    this.destroy = () =>{
        if(_chart){
            _chart.destroy()
            _chart = undefined
        }
    }

    const updateChart = (station) =>{
        //lista de medições
        let measurements = Array.isArray(station) ? station.reduce((a, c) => c.measurements && Array.isArray(c.measurements) ?  [...a, ...c.measurements] : a, []) : station.measurements
        //séries
        let series = generateSeries(measurements)

        console.log(series);
        

        //plotlines
        let plotlines = generatePlotLines(station)

        _chart.update({
            series: series
        })
        _chart.yAxis[0].update({
            plotLines: plotlines['level']
        });

        setChartLimits(plotlines,station.measurements)
    }

    const setChartLimits = (plotlines, measurements, data_type) =>{
        if(Object.keys(plotlines).length > 0 && data_type.includes('level')){
            //lista de valores das plotlines
            let plot_values = plotlines['level'].map(x=>x.value)

            //valores das plotlines + valores das medições
            let all_values = [...plot_values, ...measurements.map(x=>x.value/100)]

            //definindo o minimo e maximo do eixo Y
            _chart.yAxis[0].setExtremes(Math.min(...all_values), Math.max(...all_values))
        } else {
            _chart.yAxis[0].setExtremes()
        }
        
    }



    function generatePlotLines(station){
        let reference_values = station.reference_values
        let plotlines = {}
        if(reference_values){
            let fields = ['extravasation', 'emergency', 'alert', 'attention']
            fields.forEach(field=>{
                if(reference_values.values[field]){
                    plotlines['level'] = plotlines['level'] || []
                    plotlines['level'].push({
                        value: parseFloat(reference_values.values[field])/100,
                        dashStyle: 'shortdash',
                        color: stationHelper.colorByReference(field).full,
                        width: 2,
                        zIndex: 5,
                        label: {
                            text: `<div style="font-size:x-small;border-radius:3px;padding:1px 3px;background-color:${stationHelper.colorByReference(field).full};color:white">${locale.t(field).toUpperCase()}</div>`,
                            useHTML: true
                        }
                    })
                }
                
            })
        }
        return plotlines
    }

    function generateSeries(measurements,series_options = {}){
        //PREMISSA 10/11/2023: medições de múltiplos postos = postos PLU

        measurements = measurements.sort((x,y)=>  new Date(x.date) - new Date(y.date))
        
        let series = []
        let data_value = {}//chuva nivel
        let data_read_value = {} //chuva_acumulada vazao
        let data_type = store.informationCardStore.getDataType() //esperado ['level','flow', 'rain']

        if(measurements.length > 0){
            measurements.forEach(measurement =>{
                data_value[`${measurement.prefix}-${measurement.station_type_id}`] = data_value[`${measurement.prefix}-${measurement.station_type_id}`] || [] //criando caso não exista
                data_value[`${measurement.prefix}-${measurement.station_type_id}`].push({x:moment(measurement.date, "YYYY-MM-DDTHH:mm:ss.SSSZ").subtract(3, 'hours').valueOf(), y:parseFloat((measurement.station_type_id.toString() === '1' ? measurement.value/100 : measurement.value).toFixed(3))})

                if(measurement.read_value >=0){
                    data_read_value[`${measurement.prefix}-${measurement.station_type_id}`] = data_read_value[`${measurement.prefix}-${measurement.station_type_id}`] || [] //criando caso não exista
                    data_read_value[`${measurement.prefix}-${measurement.station_type_id}`].push({x:moment(measurement.date, "YYYY-MM-DDTHH:mm:ss.SSSZ").subtract(3, 'hours').valueOf(), y:(measurement.read_value)})
                }
            })

            if(Object.keys(data_value).length == 1){
                let axis = 0
                if(data_type.includes('level')){
                    series.push(
                        {
                            name: 'NÍVEL',
                            data: data_value[Object.keys(data_value)[0]],
                            yAxis: axis,
                            type: 'line'
                        }
                    );
                    axis = 1
                }
                if(data_type.includes('flow')){
                    let dam_id = store.informationCardStore.getDamId()
                    let data = data_read_value[Object.keys(data_read_value)[0]]
                    if(dam_id){
                        data = calculateDamGates(data)
                    }
                    series.push(
                        {
                            name: 'VAZÃO',
                            data: data,
                            yAxis: axis,
                            type: 'line'
                        }
                    );
                }
                
            } else {
                //postos plu
                $.each(data_value, (station_id, data)=>{
                    series.push(
                        {
                            name: station_id.split('-')[0],
                            data: data,
                            yAxis: 0,
                            type: 'column'
                        }
                    );
                })

                //média de chuva acumulada por timestamp
                let acum_series = {}
                let acumSeries = []
                $.each(data_value, (key, data)=>{
                    data.forEach(value=>{
                        acum_series[value.x] = acum_series[value.x] || []
                        acum_series[value.x].push(value.y)
                    })
                })

                //sort pois nem sempre o timestamp fica na ordem correta
                const entries = Object.entries(acum_series);
                entries.sort(([a], [b]) => parseInt(a) - parseInt(b));
                const sortedAcumSeries = Object.fromEntries(entries);


                let accum = 0
                $.each(sortedAcumSeries, (timestamp, array)=>{
                    let value = _.mean(array)
                    accum += value
                    acumSeries.push([parseInt(timestamp), accum])
                })

                //adicionando série de média de chuva acumulada
                series.push(
                    {
                        name: 'MÉDIA ACUMULADA',
                        data: acumSeries,
                        yAxis: 1,
                        type: 'line'
                    }
                );
            }
            
        }
        return series
    }

    const generateChart = (station) =>{
        
        let measurements = Array.isArray(station) ? station.reduce((a, c) => c.measurements && Array.isArray(c.measurements) ?  [...a, ...c.measurements] : a, []) : station.measurements

        let series = generateSeries(measurements)        

        let plotlines = generatePlotLines(station)

        let data_type = store.informationCardStore.getDataType()
        
        _chart = Highcharts.chart(elements.container, {
            chart:{
                type: 'line',
            },
            title:{
                text: ''
            },
            yAxis: [
                {
                    title: {
                        text: data_type.includes('rain') ? 'Eventos' : data_type.includes('flow') ? 'Vazão' : ''
                    },
                    plotLines: data_type.includes('level') ? plotlines['level'] : '', 
                    labels:{
                        format: `{value} ${data_type.includes('level') ? 'm' : data_type.includes('flow') ? 'm³s' : 'mm'}`,
                    }
                },
                {
                    title: {
                        text: data_type.includes('rain') ? 'Chuva acumulada' : ''
                    },
                    opposite:true,
                    labels:{
                        format: '{value} mm',
                    }
                }
                ,
            ],
            xAxis: {
                title:{

                },
                
                type: 'datetime'
            },  
            tooltip:{
                shared:true,
                formatter: function (e){
                    let html = ""
                    html += "<span style='font-size: x-small'>" + moment(this.x).format('DD/MM/YYYY HH:mm') + "</span><br>"
                    $.each(this.points, function(index, point){
                        let text = ""
                        let name = point.series.userOptions.name
                        let gates_count = point.point.options.a || undefined
                        let value = point.point.options.y
                        text += name+': <b><span style="color:'+ point.color +'">' + (data_type.includes('rain') ? value.toFixed(2) : value.toFixed(3))  +'</span></b><br/>'  
                        if(gates_count>=0){
                            text += '<b>Comportas abertas: ' + gates_count + '</b><br>'
                        }
                        html += text
                    })
                    return html
                }
            },
            plotOptions: {
                series: {
                    label: {
                        connectorAllowed: false
                    },
                    dataLabels: {
                        enabled: data_type.includes('level') || data_type.includes('flow') ? true : false,
                        useHTML:true,
                        formatter: function(){
                            const getStyle = value =>{
                                let status = stationHelper.referenceByValue(station.id, value*100);
                                if(status){
                                    let colors = stationHelper.colorByReference(status)
                                    return `border:1px solid ${colors.full};backgroundColor: ${colors.light}`
                                }
                            }
                            //exibir label apenas no valor max e min
                            let maxIndex = this.series.yData.indexOf(Math.max(...this.series.yData))
                            let minIndex = this.series.yData.indexOf(Math.min(...this.series.yData))
                            let maxTimestamp = this.series.xData[maxIndex]
                            let minTimestamp = this.series.xData[minIndex]

                            if(this.x === maxTimestamp){
                                
                                return `<div class='data-label-container data-label-max' style='${getStyle(this.y)}'>MAX: ${this.y}</div>`
                            } else if(this.x === minTimestamp){
                                return `<div class='data-label-container data-label-min' style='${getStyle(this.y)}'>MIN: ${this.y}</div>`
                            }
                        }
                    }
                }
            },
            series: series
        
        });

        setChartLimits(plotlines,station.measurements,data_type)
    }

    const calculateDamGates = measurements=>{
        let dam_id = store.informationCardStore.getDamId()
        let dam = store.damStore.getDam(dam_id)
        let events = JSON.parse(JSON.stringify(Object.values(dam.events)))

        events.map(x=>x.start_date = new Date(x.start_date).getTime())

        measurements.forEach((timestamp)=>{
            let obj = {start_date:timestamp.x}
            let new_array = [...events, obj]
            let sort = _.sortBy(new_array, ['start_date'])
            let indexOf = sort.findIndex(x=>x.start_date === timestamp.x)
            let before_event = sort[indexOf - 1]
            let after_event = sort[indexOf + 1]

            if(before_event){
                let gates = _.get(before_event, 'options.gates')
                if(gates){
                    let count = Object.values(gates).filter(x=>x.status === 'true' || x.status === true).length
                    timestamp.y *= count
                    timestamp.a = count //comportas
                }
            }
        })
        
        return measurements 

        // temp2.findIndex(x=>x.start_date === 1699896000000)
    }
}

Chart.prototype = Object.create(BaseConstructor.prototype)